module.exports = __webpack_public_path__ + "img/pmg-logo-white.c03a3032.png";